import { useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import "./HeaderComponent.scss";
import LogoTitle from "../imgs/LogoTitle.svg";
import userNotFoundImg from "../imgs/user.png";

function HeaderComponent({ title, id }) {
  const cookies = new Cookies(null, { path: "/" });

  let user = "";

  const pravnoLice = cookies.get("pravnoLice");
  const fizickoLice = cookies.get("fizickoLice");

  if (pravnoLice) {
    user = pravnoLice.ime;
  } else if (fizickoLice) {
    user = fizickoLice.ime;
  } else {
    user = title;
  }

  return (
    <header id="header">
      {title ? (
        <h1 id={id}>{title}</h1>
      ) : (
        <>
          <h1 id={id}>{user}</h1>
          <UserSection
            user={user}
            promjenaPassworda={pravnoLice ? "pravnog-lica" : "fizickog-lica"}
          />
        </>
      )}

      <img
        src={LogoTitle ? LogoTitle : userNotFoundImg}
        alt="logo"
        id="header-logo"
      />
    </header>
  );
}

function UserSection({ user, promjenaPassworda }) {
  const navigate = useNavigate();

  if (user) {
    return (
      <div>
        <p onClick={() => navigate(`/promjena-passworda-${promjenaPassworda}`)}>
          Promjena lozinke
        </p>
        <p onClick={() => navigate("/logout")}>Odjava</p>
      </div>
    );
  } else {
    return null;
  }
}

export default HeaderComponent;
